import React from 'react';
import { TextField, Box } from '@mui/material';

export interface RatingPointRowProps {
  index: number;
  value: number | '';
  label?: string;
  onChange: (value: number | '') => void;
  onCommit: () => void;
}

const RatingPointRow: React.FC<RatingPointRowProps> = React.memo(({ index, value, onChange, onCommit }) => {
  return (
    <Box sx={{ display: 'flex', alignItems: 'center' }}>
      <TextField
        fullWidth
        type="text"
        label={`Level ${index + 1} Points`}
        InputLabelProps={{ shrink: true }}
        value={value === undefined || value === null ? '' : value}
        onChange={(e) => {
          const raw = e.target.value;
          if (/^\d*$/.test(raw)) {
            onChange(raw === '' ? '' : Number(raw));
          }
        }}
        onBlur={onCommit}
        onWheel={(e) => { e.preventDefault(); }}
        onKeyDown={(e) => { if (e.key === 'Enter') { e.preventDefault(); e.stopPropagation(); } }}
      />
    </Box>
  );
});

export default RatingPointRow;
